/* eslint-disable no-restricted-globals */
/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { useContext, useState } from 'react';
import { FormControl, OutlinedInput, Tooltip } from '@mui/material';
import DialogContent from '@mui/material/DialogContent';
import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import { LanguageContext } from '../../../../libs/Context';
import useCheckExistFolder from '../../customHooks/useCheckExistFolder';
import { useDispatch, useSelector } from 'react-redux';
import { catchErr } from '../../../../libs/HelperContent';
import { creatFolder } from '../../../actions/media_actions';
import { toast } from 'react-toastify';
import { setMediaKitData } from '../../../../redux/MediakitRedux';
import { useParams } from 'react-router-dom';
import { MediaContext } from '../..';
import Loading from '../../../../components/Common/Loaders/FullWidthLoader/Loading';

const NewFolderCreation = (props:any) =>
{
	const {	handleOpenCreateFolder, handleCloseCreateFolder, handleCloseMenu, edmType, parentId, getMyFolderData } = props;
	const { language } = useContext(LanguageContext);
	const { tab, setCreatLoading } = useContext(MediaContext);
	const [ folderName, setFolderName ] = useState<any>('');
	const userData = useSelector((state:any) => state?.mysession?.session);
	const { folderData, sharedData } = useSelector((state:any) => state?.mymediakit?.mediaKitData);
	const checkExistFolder = useCheckExistFolder();
	const dispatch = useDispatch();
	const folderId = useParams()?.id || '';
	const disabledVal = folderName === '';
	const [ loading, setLoading ] = useState<boolean>(false);

	const handleCreateFolder = async () =>
	{
		if (!loading)
		{
			setLoading(true);
			edmType !== 0 && setCreatLoading(true);
			const query = {
				uid     : userData?.userId,
				comid   : userData?.companyId,
				empRole : userData?.empRole,
				role    : userData?.role

			};
			const checkExist = await checkExistFolder([ folderName?.trim() ], edmType === 0 ? parentId.current : folderId, 0);

			if (checkExist?.data?.length === 0)
			{
				try
				{
					const body:any = {
						name   : folderName?.trim(),
						parent : edmType === 0 ? parentId.current : folderId,
						type   : 0
					};

					const res = await creatFolder(query, body);

					toast.success(res?.response, {
						position  : toast.POSITION.TOP_RIGHT,
						className : 'toast-message'
					});
					// const newData = [ ...res?.data;
					tab === 1
						? dispatch(setMediaKitData({ sharedData: [ res?.data, ...sharedData ] }))
						: dispatch(setMediaKitData({ folderData: [ res?.data, ...folderData ] }));

					setLoading(false);
					handleCloseCreateFolder();
					edmType === 0 && getMyFolderData();
					edmType !== 0 && handleCloseMenu();
					edmType !== 0 &&	setCreatLoading(false);
					setLoading(false);
				}
				catch (err)
				{
					setLoading(false);
					edmType !== 0 && setCreatLoading(false);
					console.log(err, '-*******');
					catchErr(err);
				}
			}

			else
			{
				setLoading(false);
				edmType !== 0 && setCreatLoading(false);
				toast.error(language.folderNameAlreadyExists, {
					position  : toast.POSITION.TOP_RIGHT,
					className : 'toast-message'
				});
			}
		}
	};
	const handleKeyDown = (e) =>
	{
		if (e.key === 'Enter' && !disabledVal)
		{
			e.preventDefault();
			handleCreateFolder();
		}
	};

	return (
		<Dialog open={handleOpenCreateFolder} fullWidth>
			<div className='flexRow alignCntr brdrBSM pdngMD'>
				<div className='flexMinWidthRow'>
					<span className='mainHdngTxt'>{language?.createNewFolder}</span>
				</div>
				<button
					tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && handleCloseCreateFolder(); }}

					className='flexAutoRow pointer' onClick={handleCloseCreateFolder}
				>
					<Tooltip title={language?.close}>
						<CloseIcon />
					</Tooltip>
				</button>
			</div>
			<DialogContent>
				{loading && <Loading />}
				<div className='flexRow alignCntr pdngBSM'>
					<h4 className='titleHeading headingMD'>{language?.folderName}</h4>
				</div>
				<FormControl size='small' fullWidth>
					<OutlinedInput
						id='renameInput'
						autoFocus
						onFocus={focus}
						onKeyDown={handleKeyDown}
						onChange={(e) => setFolderName(e.target.value.replace(/^\s+/, ''))}
						placeholder={language?.enterFolderName}
						inputProps={{ maxLength: 100 }}
					/>
				</FormControl>
			</DialogContent>
			<div className='flexRow alignCntr justifyEnd pdngMD'>
				<div className='flexInline'>
					<Button
						variant='outlined'
						size='small'
						disableElevation
						disableRipple
						tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && handleCloseCreateFolder(); }}

						onClick={handleCloseCreateFolder}
						id='cancel'
					>
						{language?.cancel}
					</Button>
				</div>
				<div className='flexInline pdngLSM'>
					<Button
						variant='contained'
						className='whiteTxt'
						size='small'
						disableElevation
						disableRipple
						disabled={disabledVal}
						onClick={handleCreateFolder}
						id='Create'
					>
						{language?.create}
					</Button>
				</div>
			</div>
		</Dialog>
	);
};

export default NewFolderCreation;
